// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".dropdown-pane[data-v-328265d0] {\n    top: 2.625rem;\n    box-sizing: border-box;\n    width: 100%\n}", "",{"version":3,"sources":["/app/app/javascript/shared/components/ui/MultiselectDropdown.vue"],"names":[],"mappings":"AAEE;IAAA,aAAA;IAAA,sBAAA;IAAA;AAAA","file":"MultiselectDropdown.vue","sourcesContent":["\n.dropdown-pane {\n  @apply box-border top-[2.625rem] w-full;\n}\n"]}]);
// Exports
module.exports = exports;
